import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-menu.css';
import { UitkMenuContainer } from './uitk-menu-container.esm.js';
import { UitkMenuTrigger } from './uitk-menu-trigger.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkMenu = /** @class */ (function (_super) {
    __extends(UitkMenu, _super);
    function UitkMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.currentIndex = 0;
        _this.menuContainerRef = React.createRef();
        _this.state = {
            animate: false,
            mounted: false
        };
        _this.toggleMenu = _this.toggleMenu.bind(_this);
        _this.handleClickEvent = _this.handleClickEvent.bind(_this);
        _this.onFauxInputClick = _this.onFauxInputClick.bind(_this);
        _this.onFauxInputKeyPress = _this.onFauxInputKeyPress.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        return _this;
    }
    UitkMenu.prototype.componentDidMount = function () {
        this.setState({
            mounted: true
        });
    };
    UitkMenu.prototype.componentWillUnmount = function () {
        var body = document.body;
        body.removeEventListener('click', this.handleClickEvent);
        body.removeEventListener('keydown', this.onKeyDown);
        body.removeEventListener('keyup', this.onKeyUp);
    };
    UitkMenu.prototype.handleClickEvent = function (e) {
        var _a = this.props, onDismiss = _a.onDismiss, disableBodyClickHandler = _a.disableBodyClickHandler;
        if (disableBodyClickHandler) {
            return;
        }
        // Controlled compontent
        var menuContainerRef = this.menuContainerRef.current;
        var menuWrapper = menuContainerRef && menuContainerRef.closest('.uitk-menu');
        // Clicked element references
        var target = e.target;
        /**
         * Checks if the menu is within a shadow Dom and if so, sets the target to the composed path rather than the root.
         * This was added because there was an edge case where the menu is within a shadow dom and would open and dismiss on the same click.
         */
        if (e.target.shadowRoot) {
            target = e.composedPath()[0];
        }
        var isClickedCheckbox = target.classList.contains('uitk-menu-checkbox');
        var clickedMenuWrapper = target.closest('.uitk-menu');
        var clickedMenuTrigger = clickedMenuWrapper && clickedMenuWrapper.querySelector('.uitk-menu-trigger');
        if ((clickedMenuTrigger && menuWrapper && !menuWrapper.contains(clickedMenuTrigger)) ||
            (!isClickedCheckbox && !target.closest('.uitk-menu'))) {
            onDismiss && onDismiss();
            this.toggleMenu(e);
        }
    };
    UitkMenu.prototype.onKeyDown = function (e) {
        var target;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            target = document.activeElement;
            if (target.classList.contains('uitk-field-select') ||
                (target.classList.contains('uitk-field-input') && target.type === 'number')) {
                return;
            }
            e.preventDefault();
        }
        var onDismiss = this.props.onDismiss;
        if (e.key !== 'Escape') {
            return;
        }
        if (onDismiss) {
            onDismiss();
        }
        this.toggleMenu(e);
    };
    UitkMenu.prototype.onKeyUp = function (e) {
        var onDismiss = this.props.onDismiss;
        var parent = this.menuContainerRef;
        var target;
        if (e.shiftKey && e.key === 'Tab') {
            target = document.activeElement;
            if (target.classList.contains('uitk-menu-trigger')) {
                return false;
            }
        }
        if (parent.current) {
            var listItems = parent.current.children[0].children;
            if (e.key === 'ArrowDown') {
                target = document.activeElement;
                if (target.classList.contains('uitk-menu-trigger')) {
                    this.currentIndex = 0;
                    listItems[this.currentIndex].focus();
                }
                else if (target.classList.contains('uitk-list-item')) {
                    var elemToFocusOn = listItems[this.currentIndex + 1];
                    if (elemToFocusOn) {
                        this.currentIndex += 1;
                        elemToFocusOn.focus();
                    }
                }
            }
            else if (e.key === 'ArrowUp') {
                target = document.activeElement;
                if (target.classList.contains('uitk-menu-trigger')) {
                    return false;
                }
                if (target.classList.contains('uitk-list-item')) {
                    var elemToFocusOn = listItems[this.currentIndex - 1];
                    if (elemToFocusOn) {
                        this.currentIndex -= 1;
                        elemToFocusOn.focus();
                    }
                }
            }
            else if (e.key === 'Tab') {
                target = document.activeElement;
                for (var i = 0; i <= listItems.length; i++) {
                    if (target === listItems[i]) {
                        this.currentIndex = i;
                    }
                }
                var isDescendant = this.isDescendant(parent, target);
                if (!isDescendant) {
                    if (onDismiss) {
                        onDismiss();
                    }
                    this.toggleMenu(e);
                }
            }
        }
    };
    UitkMenu.prototype.onFauxInputClick = function (e) {
        if (e.target.classList.contains('uitk-faux-input')) {
            this.toggleMenu(e);
        }
    };
    UitkMenu.prototype.onFauxInputKeyPress = function (e) {
        var keyValue = e.key;
        if (keyValue !== 'Enter') {
            if (e.target.classList.contains('uitk-faux-input')) {
                this.toggleMenu(e);
            }
        }
    };
    UitkMenu.prototype.toggleMenu = function (e) {
        var _a = this.props, id = _a.id, onTriggerClick = _a.onTriggerClick;
        if (onTriggerClick) {
            onTriggerClick(e, {
                id: id
            });
        }
        this.setState({
            animate: true
        });
    };
    UitkMenu.prototype.isDescendant = function (parent, child) {
        return !!parent.current.contains(child);
    };
    UitkMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, id = _a.id, isOpen = _a.isOpen;
        var _b = this.state, animate = _b.animate, mounted = _b.mounted;
        var menuContainerClasses = ['uitk-menu-container'];
        var menuClasses = getClassNameList(className, 'uitk-menu', {
            'uitk-menu-mounted': mounted
        });
        var triggerClassNames = getClassNameList('uitk-menu-checkbox', 'is-visually-hidden');
        var menuId = '';
        var childProps;
        var containerChildProps;
        var triggerProps = {
            className: triggerClassNames,
            onClick: this.toggleMenu
        };
        if (!animate) {
            menuContainerClasses.push('animation-disabled');
        }
        if (id) {
            menuId = id;
        }
        if (mounted) {
            var body = document.body;
            if (isOpen) {
                menuContainerClasses.push('uitk-menu-open');
                body.addEventListener('click', this.handleClickEvent);
                body.addEventListener('keydown', this.onKeyDown);
                body.addEventListener('keyup', this.onKeyUp);
            }
            else {
                body.removeEventListener('click', this.handleClickEvent);
                body.removeEventListener('keydown', this.onKeyDown);
                body.removeEventListener('keyup', this.onKeyUp);
            }
        }
        var containerClasses = menuContainerClasses.join(' ');
        var menuChildren = React.Children.map(children, function (child) {
            if (!React.isValidElement(child)) {
                return undefined;
            }
            switch (child.type) {
                case UitkMenuTrigger:
                    childProps = child.props;
                    return (React.createElement(UitkMenuTrigger, __assign({}, childProps, { mounted: mounted, onClick: _this.toggleMenu, isOpen: isOpen, menuId: id })));
                case UitkMenuContainer:
                    containerChildProps = child.props;
                    return (React.createElement(UitkMenuContainer, __assign({ containerClasses: containerClasses, containerRef: _this.menuContainerRef, isOpen: isOpen }, containerChildProps)));
                default:
                    return false;
            }
        });
        if (!mounted) {
            var menuIdNoJs = menuId ? "-".concat(menuId) : '';
            return (React.createElement("div", { className: menuClasses },
                React.createElement("input", __assign({ type: "checkbox", value: "selected", id: "uitk-menu-no-js".concat(menuIdNoJs), "aria-checked": isOpen }, triggerProps)),
                menuChildren));
        }
        return (
        // eslint-disable-next-line no-warning-comments
        // TODO: https://jira.expedia.biz/browse/UDS-1879
        /* eslint-disable */
        React.createElement("div", { className: menuClasses, id: menuId, onClick: this.onFauxInputClick, onKeyPress: this.onFauxInputKeyPress }, menuChildren));
    };
    UitkMenu.displayName = 'UitkMenu';
    UitkMenu.defaultProps = {
        isOpen: false,
        disableBodyClickHandler: false
    };
    return UitkMenu;
}(React.Component));

export { UitkMenu };
